<template>
  <header class="ls-topbar" v-if="isLogged">
    <div class="ls-notification-topbar" v-if="!popup">
      <div class="ls-alerts-list" role="alert">
        <a :href="linkPlans" target="_blank" class="ls-ico-cart"></a>
      </div>
      <dropdown :class="'ls-dropdown ls-user-account'">
        <a slot="trigger" href="javascript:void(0)" class="ls-ico-user">
        <span class="ls-name">{{ seller.name }}</span>
        ({{ seller.email }})
        </a>
        <nav slot="list" class="ls-dropdown-nav ls-user-menu" aria-hidden="true">
          <ul>
            <li><a href="javascript:void(0)"role="option" @click="logOut">{{ $t('application.menu_user.logout') }}</a></li>
          </ul>
        </nav>
      </dropdown>
    </div>
    <span class="ls-show-sidebar ls-ico-menu" @click="toggleSidebar"></span>
    <h1 class="ls-brand-name">
      <router-link to="/" class="ls-display-inline-block">
        <div class="ls-display-inline-block">
          <small>{{ $t('application.header.subscriptions_traycheckout') }}</small> {{ seller.trade_name }}
        </div>
      </router-link>
    </h1>
  </header>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import * as types from 'src/app/pages/auth/vuex/mutations-types'
  import Dropdown from 'src/app/components/shareds/dropdown/Dropdown'
  export default {
    name: 'header',
    props: ['popup'],
    components: { Dropdown },
    computed: {
      ...mapGetters(['isLogged', 'currentUser', 'admUser', 'user', 'seller']),
      linkPlans () {
        return '//' + window.location.host + '/subscribe'
      },
      user () {
        if (Object.keys(this.admUser).length > 0) {
          var usr = this.admUser.user
          usr.adminEmail = this.admUser.admin ? this.admUser.admin.email : ''
          return usr
        }
        return this.currentUser
      }
    },
    methods: {
      ...mapActions(['loadUser', 'loadSeller']),
      logOut () {
        this.$store.commit(types.setUserToken, '')
        this.$store.commit(types.setUser, '')
        this.$store.commit(types.setAdmUser, '')
        this.$store.commit(types.setSeller, '')
        this.$store.commit(types.setIsLogged, false)
        this.$router.push('/auth')
      },
      toggleSidebar () {
        if (document.documentElement.classList.contains('ls-sidebar-visible')) {
          document.documentElement.classList.remove('ls-sidebar-visible')
        } else {
          document.documentElement.classList.add('ls-sidebar-visible')
        }
      }
    },
    beforeMount () {
      if (!window.localStorage.subdomain) {
        this.loadSeller()
        this.loadUser()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .mail-adm {
    position: absolute;
    font-size: 11px;
    right: 0;
    float: right;
    right: 45px;
    bottom: 10px;
  }
  .img-logo {
    display:inline-block;
    vertical-align:top;
  }
  .header-name {
    display: inline-block;
  }
  .ls-user-account {
    padding: 0;
    a {
      padding: 14px 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// main.vue?1f19cc5c